import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }

  connect () {
    if (this.fired) return
    this.fired = true
    requestAnimationFrame(() => window.location.replace(this.urlValue))
  }
}
